import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { getAppCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';

// @ts-expect-error TODO type
import { titlecase } from '../../../utils/strings';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultsHeaderTitle = ({
  categoryV2,
  searchValue
}) => {
  if (searchValue) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.results.resultsPage.headingText.searchResults"
    });
  }
  if (categoryV2.length === 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.filters.category.headingText",
      options: {
        category: titlecase(unescapedText(getAppCategoryI18nKey(categoryV2[0])))
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "appMarketplace.storefront.filters.category.items.all.headingText"
  });
};
export default ResultsHeaderTitle;